import { SvgIcon, SvgIconProps } from '@material-ui/core';

const AtStopIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="2 2 21 21">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(2.000000, 2.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path
            d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,12.6521649 18.9464316,15.195704 17.0710678,17.0710678 C15.195704,18.9464316 12.6521649,20 10,20 Z M10,2.14285714 C5.66061982,2.14285714 2.14285714,5.66061982 2.14285714,10 C2.14285714,14.3393802 5.66061982,17.8571429 10,17.8571429 C14.3393802,17.8571429 17.8571429,14.3393802 17.8571429,10 C17.8492804,5.66388072 14.3361193,2.15071957 10,2.14285714 Z"
            id="Shape"
          ></path>
          <path
            d="M12.861872,14.5782176 C12.5267016,14.5802379 12.2063067,14.4404292 11.9798422,14.1933318 L9.10923609,10.9859507 C8.91625303,10.7807368 8.80256309,10.5135654 8.78849797,10.2322162 L8.78849797,6.62391242 C8.78849797,5.95964204 9.32699551,5.4211445 9.99126589,5.4211445 C10.6555363,5.4211445 11.1940338,5.95964204 11.1940338,6.62391242 L11.1940338,9.60677685 C11.1919266,9.70930686 11.2326003,9.80808561 11.3062921,9.87940424 L13.7599387,12.5736044 C14.0922491,12.9224645 14.1806567,13.4376166 13.9836735,13.8773111 C13.7866904,14.3170056 13.343417,14.5939647 12.861872,14.5782176 Z"
            id="Path"
          ></path>
        </g>
        <rect x="0" y="0" width="24" height="24"></rect>
      </g>
    </SvgIcon>
  );
};

export default AtStopIcon;
